import { useEffect, useState } from 'react';
import styles from '../main.module.scss';

let scroll: number = 0;
export default function FadeHeader({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: HTMLDivElement['className'];
}) {
  const [isVisible, setIsVisible] = useState<boolean>(true);

  useEffect(() => {
    let timer: ReturnType<typeof setTimeout> | undefined = undefined;
    const scrollHandler = () => {
      if (timer) return;
      timer = setTimeout(() => {
        setIsVisible(scroll > window.scrollY ? true : false);
        scroll = window.scrollY;
        timer = undefined;
      }, 100);
    };
    window.addEventListener('scroll', scrollHandler);
    return () => window.removeEventListener('scroll', scrollHandler);
  }, []);

  return (
    <div
      className={`${styles.fadeHeader} ${isVisible ? '' : styles.fadeOut} ${
        className ? className : ''
      }`}
    >
      {children}
    </div>
  );
}
